import { ContactSource } from "client/Api/Email/contacts";
import { RecentlyOpenedItemConfigurationProps, useResolveRecentlyOpenedItemForPersistence } from "./useResolveRecentlyOpenedItemForPersistence";
import { useCallback } from "react";
import { AppType } from "client/Api/Apps/common";
import { AnalyticsAppEventData } from "client/Api/Analytics/analytics";
import { useAnalyticsStore } from "client/Features/Analytics/analyticsStore";
import { useRecentlyOpenedResults } from "client/Features/Search/RecentSearch/Persistence/useRecentlyOpenedResults";
import { GlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/models";

export type ContactNavigationHandlerProps = {
	id: string;
	contactSource: ContactSource;
	onOpenContactDetails: (id: string, contactSource: ContactSource) => void;
}
	& RecentlyOpenedItemConfigurationProps;

export function useContactNavigationHandler(props: ContactNavigationHandlerProps): (() => void) {
	const {
		id,
		contactSource,
		onOpenContactDetails
	} = props;

	const addAnalyticsAppEvent: (data: AnalyticsAppEventData) => void = useAnalyticsStore(x => x.addAppEvent);
	const { registerFromRecentlyOpened: registerRecentlyOpenedItem } = useRecentlyOpenedResults();

	const recentlyOpenedItem: GlobalSearchItemPersistedModel = useResolveRecentlyOpenedItemForPersistence(props);

	return useCallback(
		(): void => {
			addAnalyticsAppEvent({ appType: AppType.AddressBook });
			registerRecentlyOpenedItem(recentlyOpenedItem);
			onOpenContactDetails(id, contactSource);
		},
		[
			addAnalyticsAppEvent,
			contactSource,
			id,
			onOpenContactDetails,
			recentlyOpenedItem,
			registerRecentlyOpenedItem
		]
	);
}